var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery2 vuetified position-relative mb-5" },
    [
      _c(
        "div",
        {
          staticClass: "w-100 overflow-hidden position-relative",
          style: _vm.heightStyle
        },
        [
          _c(
            "div",
            {
              staticClass:
                "position-absolute d-flex flex-row justify-content-start align-items-start gallery2__wrapper",
              style: _vm.styles
            },
            _vm._l(_vm.images, function(image, index) {
              return _c(
                "div",
                {
                  ref: "image",
                  refInFor: true,
                  staticClass: "gallery2__image",
                  style: _vm.imageWidth(index)
                },
                [
                  _c(
                    "div",
                    { staticClass: "position-relative" },
                    [
                      _c("img", { attrs: { src: image.src, alt: image.alt } }),
                      _vm._v(" "),
                      _vm.stamp.hasStamp
                        ? _c("stamp", {
                            staticClass: "stamp--overlay",
                            class: _vm.stamp.stampClasses
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "h-auto w-100 mb-0 overflow-hidden",
                    domProps: { innerHTML: _vm._s(_vm.htmlText(image.alt)) }
                  })
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gallery2__dots-container" }, [
        _c("div", { staticClass: "dots dots--left-0 dots--size-3rem" }, [
          _c(
            "button",
            {
              staticClass:
                "dot spot-background spot-front-text border-0 rounded-circle d-flex flex-row justify-content-center align-items-center",
              on: {
                click: function($event) {
                  return _vm.next(+1)
                }
              }
            },
            [_c("span", { staticClass: "icon-right-arrow" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "dot spot-background spot-front-text border-0 rounded-circle d-flex flex-row justify-content-center align-items-center",
              on: {
                click: function($event) {
                  return _vm.next(-1)
                }
              }
            },
            [_c("span", { staticClass: "icon-left-arrow" })]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }